import { useState } from "react";
import { readPosPreferences, writePosPreferences } from "../lib/local-store";
import type { PosPreferences } from "../types";

/** Cosmetic per-device toggles (Menu Photos, notifications, sounds, auto-print) — persisted in localStorage. */
export function usePosPreferences() {
  const [prefs, setPrefs] = useState<PosPreferences>(readPosPreferences);

  function setToggle(key: keyof PosPreferences, value: boolean) {
    setPrefs((prev) => {
      const next = { ...prev, [key]: value };
      writePosPreferences(next);
      return next;
    });
  }

  return { prefs, setToggle };
}
